import {
  alias, params, string, extend, arrayOf, shape, bool, number
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { wrappedProduct } from './core/RecommendationsProductPodCarousel';

const productModel = extend({}, {
  itemId: string(),
  dataSource: string(),
}, ProductPod.dataModel.product);

export const dataModel = extend({
  recsProducts:
    alias('products').params({
      itemIds: arrayOf(string().isRequired()).isRequired(),
      dataSource: string()
    }).arrayOf(productModel),
});

const requiredAttributeMetaData = {
  difficulty: string(),
  difficultyLevelImageURL: string(),
  prjDurationImageURL: string(),
  pgImageURL: string(),
  pgurl: string(),
  duration: string(),
  messaging: string(),
  batteryDesc: string(),
  batteryImageUrl: string(),
  batteryName: string(),
  batteryPlpUrl: string(),
  batteryTitle: string()
};

export const dynamicRecsDataModel = {
  recs: params({
    anchorId: string().isRequired(),
    apiName: string().isRequired(),
    storeId: string(),
    serviceType: string()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string(),
      ...requiredAttributeMetaData
    }),
    products: arrayOf(wrappedProduct)
  })
};

export const rvDataModel = {
  uds: params({
    userId: string().isRequired(),
    apiName: string().isRequired(),
    storeId: string(),
    key: string().isRequired(),
    unique: bool(),
    maxProducts: number(),
    versions: string(),
    // showPrice: bool()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      version: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string()
    }),
    products: arrayOf(wrappedProduct)
  })
};
